import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

export type StatusCellValue = string | boolean;
export type StatusColorCode = 'success' | 'danger' | 'warning' | 'info' | 'lighter' | 'light';
export type StatusCellColorMap = Map<StatusCellValue, StatusColorCode>;
export interface StatusCellsParams extends ICellRendererParams {
  colorMap: StatusCellColorMap;
  translationPath: string;
}

/**
 * @usage
 * When defining columns in the AgGrid table, provide a map that correlates each potential API response value with a specific color code.
 * Additionally, specify a translation path for the status values. This setup allows for dynamic color-coding and localization of status values in the table.
 *  {
 *     headerName: 'Status',
 *     field: 'status',
 *     cellRenderer: 'statusCell',
 *     cellRendererParams: {
 *       colorMap: new Map<StatusCellColorMap>(['Booked', 'success'], ['Cancelled', 'danger']),
 *       translationPath: 'lore.ipsum.status',
 *     }
 *   }
 */
@Component({
  standalone: true,
  selector: 'rx-applications-badge-status-cell',
  templateUrl: './badge-status-cell.component.html',
  styleUrls: ['./badge-status-cell.component.scss'],
  imports: [CommonModule, TranslocoModule],
})
export class BadgeStatusCellComponent implements ICellRendererAngularComp {
  cellTranslation!: string;
  badgeColor!: string;

  agInit(params: StatusCellsParams): void {
    if (params.value === null || params.value === undefined || params.value === '') {
      this.cellTranslation = '-';
      return;
    }
    this.cellTranslation = `${params.translationPath}.${params.value.toString().toLocaleLowerCase()}`;
    this.badgeColor = this.getColorBadge(params.colorMap, params.value);
  }

  refresh(): boolean {
    return false;
  }

  private getColorBadge(conditionMap: StatusCellColorMap, value: StatusCellValue): string {
    return conditionMap.has(value) ? `badge-${conditionMap.get(value)}` : 'badge-lighter';
  }
}
